import { api } from '@/api'
import * as _ from 'lodash-es'

export const getCustomer = async (customerId) =>
  api.get(`customers/${customerId}`)

export const getCustomers = async (params, page, owner) => {
  const requestBody = { params: { ...params } }

  if (page) {
    requestBody.params = { page }
  }

  if (owner) {
    requestBody.params.owner = owner
  }

  if (_.has(requestBody.params, 'search')) {
    requestBody.params.search = encodeURI(requestBody.params.search)
  }

  return api.get('customers', requestBody)
}

export const createCustomer = async (customerData) =>
  api.post('customers', customerData)

export const editCustomer = async (id, customerData) =>
  api.patch(`customers/${id}`, customerData)

export const deleteCustomer = async (id) => api.delete(`customers/${id}`)

export const searchFinvoiceAddresses = (businessId) =>
  api.post('incomes/invoices/e-invoice-addresses', {
    businessId
  })

export const downloadCustomers = () => api.post('customers/export')
